<template>
    <div class="flex items-center pb-1 pr-6"
        :class="{ 'cursor-pointer': ! read_only }"
        @click="select"
    >
        <div class="border flex-none h-4 h-6 mr-2 rounded-full w-6 transition-colors duration-100"
            :class="[
                { 'read_only': read_only },
                { 'on': selected },
                { 'off': ! selected },
            ]"
        ></div>

        <label class="font-semibold text-gray-700 text-label leading-none select-none"
            :class="{ 'cursor-pointer': ! read_only }"
        >
             {{ $t(label) }}
        </label>
    </div>
</template>

<script>
export default {
    props: {
        label: {},
        value: {},
        selected: {},
        read_only: { default: false },
    },

    methods: {
        select() {
            if (! this.read_only) {
                this.$emit('selected', this.value);
            }
        },
    },
}
</script>

<style scoped>
    .on {
        border-color: #3b82f6;
        background-color: #3b82f6;
    }

    .off {
        border-color: #90b1d5;
        background-color: #ffffff;
    }

    .read_only.on {
        border-color: #4299e1;
        background-color: #4299e1;
    }

    .read_only.off {
        border-color: #f5f5f5;
        background-color: #f5f5f5;
    }

    .accordion .read_only.off {
        border-color: #ffffff;
        background-color: #ffffff;
    }
</style>
